<div class="flex-row">
  <a [href]="KW_LINK" target="_blank"> {{ landRegister || '-' }} </a>
  <a
    *ngIf="landRegister"
    class="cursor-pointer mat-primary margin-left-5"
    (click)="copyToClipboard()"
    [matTooltip]="'button.clipboardValue' | locRep: { $value: lrMiddle }"
  >
    <mat-icon class="icon-20">content_copy</mat-icon>
  </a>
</div>
